<button
  type="button"
  class="theme-toggle-btn"
  (click)="toggleTheme()"
  [attr.aria-label]="isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'"
  [title]="isDark ? 'Modo oscuro activo - Click para modo claro' : 'Modo claro activo - Click para modo oscuro'">

  <span class="theme-icon">◐</span>
</button>

